import React from 'react'
import CircleIcon from '@mui/icons-material/Circle';

function FilledCircleConnector(){
    return(
        <div className="circleConnector">
            <span>|</span>
            <CircleIcon />
            <span>|</span>
        </div>
    )
}

export default FilledCircleConnector